import * as constants from './constants';

import appApi from '@/api/app';
//树组件
import { ClusterOutlined, DatabaseOutlined } from '@ant-design/icons';
import Config from '@/config';
import { $public, $catch } from '@/utils';

export const changeOrgData = (data) => {
    return {
        type: constants.ORG_DEVICE_DATA,
        data
    };
};


//缓存采集点类型列表数据
export const patchTypeList = (data) => {
    return {
        type: constants.PATCH_TYPE_DATAS,
        data
    };
};


//更新组件树数据
const updateTreeData = (list, key, children) => {
    return list.map((node) => {
        if (node.key === key) {
            //添加 上级名称 name_id-deviceId_id
            const _child = children.map(el => {
                const _name = node.type === Config.nodeType['CHILD_DEVICE'] ? (node?.name +'___'+ node?.type +'___'+ node?.id + '___' + node?.extraInformation?.deviceNo) : (node?.name +'___'+ node?.type +'___'+ node?.id);
                return {
                    ...el,
                    deviceNo: el.type === Config.nodeType['CHILD_DEVICE'] ? el?.extraInformation?.deviceNo : null,  //方便取值
                    parentName: node.parentName ? (node.parentName + '---' + _name) : _name
                };
            });
            return { ...node, children: _child };
        }

        if (node.children) {
            return { ...node, children: updateTreeData(node.children, key, children) };
        }

        return node;
    });
}


//处理  获取设备树数据 方法
const formatDeviceData = (list, isleaf) => {
    return (list || []).map(el => {
        const icon = (el.type === Config.nodeType['GATEWAY'] || el.type === Config.nodeType['DEVICE']) ? <ClusterOutlined /> : el.type === Config.nodeType['CHILD_DEVICE'] ? <DatabaseOutlined /> : null;
        // const selectable = (el.type === Config.nodeType['GROUP'] || el.type === Config.nodeType['GATEWAY'] || el.type === Config.nodeType['CHILD_DEVICE'] || el.type === Config.nodeType['DEVICE']) ? true : false;
        if(el.children && el.children.length){
            el.children = formatDeviceData(el.children,isleaf)
        }
        return {
            ...el,
            key: el.id,
            title: el.name,
            isLeaf: isleaf === true ? true : el.leaf,
            icon,
            selectable: true
        };
    });
};


//获取采集点类型列表-树的1级
export const getCollectPointTypes = () => {
    return (dispatch) => {
        appApi.getCollectPointTypes()
            .then(res => {
                //默认配置项目
                const _list = res || [];
                const _data = _list.map(item => {
                    return {
                        ...item,
                        key: item.groupCode,
                        title: item.groupName,
                        id: item.groupCode,
                        name: item.groupName,
                        isLeaf: false,
                        type: "collectPointGroup",
                        selectable: true,
                    };
                });
                dispatch(changeOrgData(_data));
                //
                dispatch(patchTypeList(_list));  //采集点类型
            })
    };
};


//获取设备树数据
export const getOrgDeviceTreeData = (data, oldList) => {
    return (dispatch) => {
        return new Promise(resolve => {
            appApi.getOrgDeviceTreeData(data)
                .then(res => {
                    //默认配置项目
                    let list = formatDeviceData(res);
                    if(list.length) {
                        if(oldList) list = updateTreeData(oldList, data.id, list);
                        dispatch(changeOrgData(list));
                        //完成
                        return resolve(list);
                    }
                    $public.suc('暂无数据');
                    return resolve(null);
                })
        });
    };
};




//获取设备树数据 搜索
export const getOrgDeviceTreeDataSearch = (data) => {
    return (dispatch) => {
        appApi.getOrgDeviceTreeDataSearch(data)
            .then(res => {
                //默认配置项目
                let list = formatDeviceData(res);
                if(list.length) {
                    dispatch(changeOrgData(list));
                } else {
                    $public.suc('暂无数据');
                }
            })
    };
};


// 处理面包绡
export const orgBreadCrumbsInit = (data) => {
    return {
        type: constants.ORG_BREAD_CRUMBS,
        data
    };
};

//处理缓存数据  方法
export const setOrgBreadCrumbs = (node) => {
    if(!node){
        return _catchBreadCrumbsData({
            breadCrumbs: [],
            device: {}
        });
    }

    const _parents = node?.parentName?.split('---') || [];
    const _list = _parents.map(el => {
        const _node = el?.split('___');
        return {
            name: _node[0],
            type: _node[1],
            id: _node[2],
            deviceNo: _node[3] ? _node[3] : null,
        };
    });

    //加入当前
    const _nowData = {
        name: node?.name,
        type: node?.type,
        id: node?.id,
        deviceNo: node?.deviceNo || null,
        extraInformation: node?.extraInformation || {},
    };
    _list.push(_nowData);

    //写入数据
    const _data = {
        breadCrumbs: _list,
        device: _nowData
    };

    //缓存数据
    return _catchBreadCrumbsData(_data);
};


//缓存数据
const _catchBreadCrumbsData = (data) => {
    //缓存数据
    $catch.setSessionItem(constants.ORG_BREAD_CRUMBS_CATCH, data);
    return orgBreadCrumbsInit(data);
};
